<div class="genie-page">

  <!-- Page Header -->
  <div class="genie-page-header">
    <div class="header-left">
      <div class="backButton" (click)="builderService.navigateBack()">
        <img src="/assets/icons/arrow-left.svg" [alt]="'Go back' | translate" />
      </div>
      <h1 class="genie-page-title">
        <ng-container *ngIf="!editPage">{{ 'Create Coupon' | translate }}</ng-container>
        <ng-container *ngIf="editPage">{{ 'Edit Coupon' | translate }}</ng-container>
      </h1>
      <p class="genie-page-subtitle">{{ 'Create coupon and manage details for it.' | translate }}</p>
    </div>
    <div class="header-right">
      <button class="genie-btn secondary" type="button" (click)="builderService.navigateBack()">{{ 'Cancel' | translate }}</button>
      <button class="genie-btn primary" type="submit" form="couponFormEl">
        <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.36589 0.699219V10.0326M0.699219 5.36589H10.0326" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <ng-container *ngIf="!editPage">{{ 'Create Coupon' | translate }}</ng-container>
        <ng-container *ngIf="editPage">{{ 'Save Changes' | translate }}</ng-container>
      </button>
    </div>
  </div>

  <form id="couponFormEl" (ngSubmit)="onSubmit(f.value)" #f="ngForm">

    <!-- ── Coupon Details Card ── -->
    <div class="form-card">
      <div class="card-header">
        <h2>{{ 'Coupon Details' | translate }}</h2>
      </div>
      <div class="card-body">

        <div class="fields-row">
          <!-- Coupon Name -->
          <div class="field-group">
            <label>{{ 'Coupon Name' | translate }}</label>
            <input
              class="field-input"
              name="couponName"
              required
              [(ngModel)]="couponName"
              #couponInput="ngModel"
              [placeholder]="'Summer sales 2025' | translate"
            />
            <span class="field-error" *ngIf="couponInput.touched && couponInput.errors?.required">{{ 'Coupon name is required.' | translate }}</span>
            <span class="field-error" *ngIf="invalidationMessage">{{ invalidationMessage }}</span>
          </div>

          <!-- Discount Criteria -->
          <div class="field-group">
            <label>{{ 'Discount Criteria' | translate }}</label>
            <select
              class="field-input field-select"
              name="selectedCriteria"
              required
              [(ngModel)]="selectedCriteria"
              #criteriaSelectInput="ngModel"
            >
              <option value="" disabled>{{ 'Select Discount Criteria' | translate }}</option>
              <option *ngIf="!vendor.isMultiVendor" value="fixed_products_discount">{{ 'Fixed Products Discount' | translate }}</option>
              <option *ngIf="!vendor.isMultiVendor" value="fixed_categories_discount">{{ 'Fixed Category Discount' | translate }}</option>
              <option value="whole_cart_discount">{{ 'Whole Cart Discount' | translate }}</option>
            </select>
            <span class="field-error" *ngIf="criteriaSelectInput.touched && criteriaSelectInput.errors?.required">{{ 'Please select a discount criteria.' | translate }}</span>
          </div>
        </div>

        <div class="fields-row">
          <!-- Discount Type -->
          <div class="field-group">
            <label>{{ 'Discount Type' | translate }}</label>
            <select
              class="field-input field-select"
              id="selectedType"
              name="selectedType"
              required
              [(ngModel)]="selectedType"
              #selectedTypeInput="ngModel"
            >
              <option value="" disabled>{{ 'Select Discount Type' | translate }}</option>
              <option *ngFor="let type of discountTypeMap | keyvalue" [value]="type.key">{{ type.value }}</option>
            </select>
            <span class="field-error" *ngIf="selectedTypeInput.touched && selectedTypeInput.errors?.required">{{ 'Please select a discount type.' | translate }}</span>
          </div>

          <!-- Coupon Amount (conditional on type) -->
          <div class="field-group">
            <label>{{ 'Coupon Amount' | translate }}</label>

            <div *ngIf="!isPercentage() && !isAmount()">
              <div class="field-input-wrapper">
                <input type="number" min="1" class="field-input-inner" name="discountDefaultInput" required [(ngModel)]="discountDefaultInput" #discountInput="ngModel" placeholder="0" />
              </div>
              <span class="field-error" *ngIf="discountInput.touched">{{ 'Please choose a discount type first.' | translate }}</span>
            </div>

            <div *ngIf="isPercentage()">
              <div class="field-input-wrapper">
                <input type="number" min="1" class="field-input-inner" name="discountPercentage" required [(ngModel)]="discountPercentage" #discountPer="ngModel" placeholder="0" />
                <span class="input-suffix">%</span>
              </div>
              <span class="field-error" *ngIf="discountPer.errors?.min || discountPer.errors?.required">{{ 'Discount Percentage is required.' | translate }}</span>
            </div>

            <div *ngIf="isAmount()">
              <div class="field-input-wrapper">
                <input type="number" min="1" class="field-input-inner" name="discountAmount" required [(ngModel)]="discountAmount" #discountAmountInput="ngModel" placeholder="0" />
                <span class="input-suffix currency-symbol">{{ settingsService.currency }}</span>
              </div>
              <span class="field-error" *ngIf="discountAmountInput.errors?.min">{{ 'Discount Amount is required.' | translate }}</span>
            </div>
          </div>
        </div>

        <!-- Products Table -->
        <div [class.hidden]="!showProducts()">
          <div class="sub-card">
            <div class="sub-card-header">
              <p>Select Specific Product(s)</p>
              <div class="sub-search">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.75 10.5C8.37335 10.5 10.5 8.37335 10.5 5.75C10.5 3.12665 8.37335 1 5.75 1C3.12665 1 1 3.12665 1 5.75C1 8.37335 3.12665 10.5 5.75 10.5Z" stroke="#ADADAD" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M11 11L10 10" stroke="#ADADAD" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <input #query (keyup)="filterProducts(query.value)" type="text" [placeholder]="'Search products' | translate" />
              </div>
            </div>
            <div class="genie-table-wrapper">
              <table class="genie-table">
                <thead>
                  <tr>
                    <th>Image</th>
                    <th>Name</th>
                    <th>Stock</th>
                    <th>Price</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let product of productsDataSource.data">
                    <td class="image-cell">
                      <mat-checkbox [checked]="isChecked(product, 'product')" class="products-checkbox" (change)="onProductSelect(product, $event)"></mat-checkbox>
                      <div class="productImgContainer">
                        <img loading="lazy" [src]="product.imageUrl | primaryImage" class="productImg" alt="Product" />
                      </div>
                    </td>
                    <td>{{ product.productName }}</td>
                    <td>{{ getStock(product) > 0 ? product.productStock : 'Out of Stock' }}</td>
                    <td>{{ product.salePrice ? product.regularPrice + ' / ' + product.salePrice : product.regularPrice }}</td>
                    <td>{{ product.date }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="genie-pagination">
              <div class="pagination-info">
                <span class="current-page">{{ pageIndex + 1 }}</span>
                <span class="page-separator">of</span>
                <span class="total-pages">{{ filteredProducts.length > 0 ? (filteredProducts.length / pageSize | number:'1.0-0') : 1 }}</span>
              </div>
              <div class="pagination-controls">
                <button type="button" class="page-btn" [disabled]="pageIndex === 0" (click)="onPageChange({ pageIndex: pageIndex - 1, pageSize: pageSize, length: filteredProducts.length, previousPageIndex: pageIndex })">
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M6.25 7.5L3.75 5L6.25 2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" /></svg>
                </button>
                <button type="button" class="page-btn" [disabled]="(pageIndex + 1) * pageSize >= filteredProducts.length" (click)="onPageChange({ pageIndex: pageIndex + 1, pageSize: pageSize, length: filteredProducts.length, previousPageIndex: pageIndex })">
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M3.75 7.5L6.25 5L3.75 2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" /></svg>
                </button>
              </div>
            </div>
          </div>

          <div *ngIf="selectedProducts.length > 0" class="sub-card sub-card-selected">
            <div class="sub-card-header">
              <p>Selected Products</p>
            </div>
            <div class="genie-table-wrapper">
              <table class="genie-table">
                <thead>
                  <tr>
                    <th>Select</th>
                    <th>Image</th>
                    <th>Name</th>
                    <th>Stock</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let product of selectedProductsDataSource.data">
                    <td>
                      <mat-checkbox [checked]="isChecked(product, 'product')" (change)="onProductSelect(product, $event)"></mat-checkbox>
                    </td>
                    <td class="image-cell">
                      <div class="productImgContainer">
                        <img loading="lazy" [src]="product.imageUrl | primaryImage" class="productImg" alt="Product" />
                      </div>
                    </td>
                    <td>{{ product.productName }}</td>
                    <td>{{ getStock(product) > 0 ? product.productStock : 'Out of Stock' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Categories Table -->
        <div *ngIf="showCategories()">
          <div class="sub-card">
            <div class="sub-card-header">
              <h3>{{ 'Select Specific Categories' | translate }}</h3>
              <div class="sub-search">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.75 10.5C8.37335 10.5 10.5 8.37335 10.5 5.75C10.5 3.12665 8.37335 1 5.75 1C3.12665 1 1 3.12665 1 5.75C1 8.37335 3.12665 10.5 5.75 10.5Z" stroke="#ADADAD" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M11 11L10 10" stroke="#ADADAD" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <input #queryC (keyup)="filterCategories(queryC.value)" type="text" [placeholder]="'Search categories' | translate" />
              </div>
            </div>
            <div class="category-list">
              <div class="category-row" *ngFor="let category of categoriesDataSource.data">
                <mat-checkbox [checked]="isChecked(category, 'category')" (change)="onCategorySelect(category, $event)"></mat-checkbox>
                <img loading="lazy" [src]="category.categoryImage || 'assets/images/empty-image.png'" class="cat-image" alt="" />
                <span class="cat-name">{{ category.categoryName }}</span>
              </div>
            </div>
          </div>

          <div *ngIf="selectedCategories.length > 0" class="sub-card sub-card-selected">
            <div class="sub-card-header">
              <p>Selected Categories</p>
            </div>
            <div class="category-list selected-cats">
              <div class="category-row" *ngFor="let cat of selectedCategories">
                <mat-checkbox [checked]="isChecked(cat, 'category')" (change)="onCategorySelect(cat, $event)"></mat-checkbox>
                <img loading="lazy" [src]="cat.categoryImage || 'assets/images/empty-image.png'" class="cat-image" alt="" />
                <span class="cat-name">{{ cat.categoryName }}</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- ── Bottom Row: Usage + Expiration ── -->
    <div class="bottom-cards">

      <!-- Coupon Usage Card -->
      <div class="form-card">
        <div class="card-header">
          <h2>{{ 'Coupon Usage' | translate }}</h2>
        </div>
        <div class="card-body">
          <div class="fields-row">
            <div class="field-group">
              <label>{{ 'Usage Limit' | translate }}</label>
              <input type="number" min="1" required class="field-input" name="usageTime" [(ngModel)]="usageTime" #usageTimeInput="ngModel" [placeholder]="'Unlimited' | translate" />
              <span class="field-error" *ngIf="usageTimeInput.touched && (usageTimeInput.errors?.required || usageTimeInput.errors?.min)">{{ 'Usage Limit is required.' | translate }}</span>
            </div>
            <div class="field-group">
              <label>{{ 'Per User Limit' | translate }}</label>
              <input type="number" min="1" required class="field-input" name="usageTimes" [(ngModel)]="usageTimes" #usageTimesInput="ngModel" [placeholder]="'Unlimited' | translate" />
              <span class="field-error" *ngIf="usageTimesInput.touched && (usageTimesInput.errors?.required || usageTimesInput.errors?.min)">{{ 'Per User Limit is required.' | translate }}</span>
            </div>
          </div>
          <div class="fields-row">
            <div class="field-group">
              <label>{{ 'Minimum' | translate }}</label>
              <div class="field-input-wrapper">
                <span class="input-prefix currency-symbol">{{ settingsService.currency || '$' }}</span>
                <input type="number" min="1" required class="field-input-inner" name="min" [(ngModel)]="min" #minInput="ngModel" placeholder="0" />
              </div>
              <span class="field-error" *ngIf="minInput.touched && (minInput.errors?.required || minInput.errors?.min)">{{ 'Minimum amount is required.' | translate }}</span>
            </div>
            <div class="field-group">
              <label>{{ 'Maximum' | translate }}</label>
              <div class="field-input-wrapper">
                <span class="input-prefix currency-symbol">{{ settingsService.currency || '$' }}</span>
                <input type="number" min="1" required class="field-input-inner" name="max" [(ngModel)]="max" #maxInput="ngModel" placeholder="0" />
              </div>
              <span class="field-error" *ngIf="maxInput.touched && (maxInput.errors?.required || maxInput.errors?.min)">{{ 'Maximum amount is required.' | translate }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Expiration Card -->
      <div class="form-card">
        <div class="card-header">
          <h2>{{ 'Expiration' | translate }}</h2>
        </div>
        <div class="card-body expiration-body">
          <div class="fields-row">
            <div class="field-group">
              <label>{{ 'Expiration Date' | translate }}</label>
              <div class="picker-wrapper">
                <svg class="picker-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.66667 1.16675V2.91675M9.33333 1.16675V2.91675M1.75 5.25008H12.25M2.33333 2.91675H11.6667C11.9889 2.91675 12.25 3.17784 12.25 3.50008V11.6667C12.25 11.9889 11.9889 12.2501 11.6667 12.2501H2.33333C2.01117 12.2501 1.75 11.9889 1.75 11.6667V3.50008C1.75 3.17784 2.01117 2.91675 2.33333 2.91675Z" stroke="#ADADAD" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <input
                  class="picker-input"
                  [matDatepicker]="expirationPicker"
                  [(ngModel)]="dateInput"
                  name="dateInput"
                  placeholder="mm/dd/yyyy"
                  readonly
                  required
                  #dateInputNg="ngModel"
                />
                <mat-datepicker-toggle [for]="expirationPicker" class="picker-toggle"></mat-datepicker-toggle>
                <mat-datepicker #expirationPicker></mat-datepicker>
              </div>
              <span class="field-error" *ngIf="dateInputNg.invalid && (dateInputNg.dirty || dateInputNg.touched)">{{ 'Expiration date is required.' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ── Users Section (edit mode only) ── -->
    <div class="form-card" *ngIf="editPage">
      <div class="card-header">
        <h2>{{ 'Users' | translate }}</h2>
        <div class="sub-search">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.75 10.5C8.37335 10.5 10.5 8.37335 10.5 5.75C10.5 3.12665 8.37335 1 5.75 1C3.12665 1 1 3.12665 1 5.75C1 8.37335 3.12665 10.5 5.75 10.5Z" stroke="#ADADAD" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M11 11L10 10" stroke="#ADADAD" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <input type="text" [placeholder]="'Search users' | translate" [(ngModel)]="searchText" (input)="applyFilter()" name="searchText" />
        </div>
      </div>
      <div class="genie-table-wrapper">
        <table class="genie-table">
          <thead>
            <tr>
              <th>{{ 'ID' | translate }}</th>
              <th>{{ 'User Name' | translate }}</th>
              <th>{{ 'User uses' | translate }}</th>
              <th>{{ 'Email' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let user of getPagedUsers()">
              <td>{{ user.uid }}</td>
              <td>{{ user.displayName }}</td>
              <td>{{ user.userUses }}</td>
              <td>{{ user.email }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="genie-pagination">
        <div class="pagination-pageSize">
          <span class="pageSize-label">Items per page:</span>
          <select class="pageSize-select" [(ngModel)]="usersPageSize" name="usersPageSize" (change)="usersPageIndex = 0">
            <option *ngFor="let size of [5, 10, 20]" [value]="size">{{ size }}</option>
          </select>
        </div>
        <div class="pagination-info">
          <span class="current-page">{{ usersPageIndex + 1 }}</span>
          <span class="page-separator">of</span>
          <span class="total-pages">{{ getTotalUserPages() }}</span>
        </div>
        <div class="pagination-controls">
          <button type="button" class="page-btn" [disabled]="usersPageIndex === 0" (click)="usersPageIndex = usersPageIndex - 1">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M6.25 7.5L3.75 5L6.25 2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </button>
          <button type="button" class="page-btn" [disabled]="usersPageIndex >= getTotalUserPages() - 1" (click)="usersPageIndex = usersPageIndex + 1">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M3.75 7.5L6.25 5L3.75 2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </button>
        </div>
      </div>
    </div>

  </form>
</div>
